// Google Analytics 4 integration
// Tracking only core events as specified

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

// GA4 Measurement ID from environment variable
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || '';

// initGA is no longer needed - GA4 is loaded directly in index.html
// Keeping this as a no-op for backwards compatibility
export function initGA() {
  // GA4 script is now loaded in index.html
}

// Core tracking events
export const trackEvent = {
  playStart: (matchId: string, mode: string, difficulty: string) => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'play_start', {
      match_id: matchId,
      mode,
      difficulty,
    });
  },

  playComplete: (matchId: string, durationMs: number, clicks: number, success: boolean) => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'play_complete', {
      match_id: matchId,
      duration_ms: durationMs,
      clicks,
      success,
    });
  },

  runCompleted: (runId: string, matchId: string, isPublic: boolean) => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'run_completed', {
      run_id: runId,
      match_id: matchId,
      is_public: isPublic,
    });
  },

  beatThisRunClicked: (runId: string) => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'beat_this_run_clicked', {
      run_id: runId,
    });
  },

  removeAdsClicked: () => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'remove_ads_clicked');
  },

  purchaseSuccess: () => {
    if (!GA_MEASUREMENT_ID) return;
    window.gtag('event', 'purchase_success');
  },
};
